var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"px-0 px-md-1",attrs:{"fluid":""}},[_c('div',{staticClass:"tables-basic mt-3"},[_c('Sidebar',{attrs:{"validaFilter":_vm.validaFilter,"validaHelp":_vm.validaHelp}}),(_vm.nuevaPeticion)?_c('Tablero',{key:_vm.key.tablero,attrs:{"busqueda":_vm.busquedaTablero}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }